import PropTypes from 'prop-types';

const tabPropType = {
  name: PropTypes.string,
  label: PropTypes.string,
  visible: PropTypes.func,
  TabContent: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
    .isRequired,
  tabContentPadding: PropTypes.oneOf(['none', 'normal'])
};

export default tabPropType;
